// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_asJxw","dbox":"index_dbox_b6HTw"};